import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { AuthGuardService } from '../../services/auth-guard.service';
import { InitialDataResolver } from '../../services/initial-data.resolver';
import { MobileCaptureWrapperComponent } from '../mobile-capture/mobile-capture-wrapper.component';
import { MobileCaptureComponent } from '../mobile-capture/mobile-capture.component';

const routes: Routes = [
  // {
  //   path: '',
  //   loadChildren: () => import('../landing-layout/landing.routing').then(m => m.LandingRoutes)
  // },
  {
    path: 'auth',
    loadChildren: () => import('../authentication/authentication.routing').then(m => m.AuthenticationRoutes),
    resolve: {
      initialData: InitialDataResolver
    }
  },
  {
    path: 'app',
    loadChildren: () => import('../admin-layout/admin.routing').then(m => m.AdminRoutes),
    data: {},
    canMatch: [(route: ActivatedRouteSnapshot) => inject(AuthGuardService).isLoggedIn(route)],
    resolve: {
      initialData: InitialDataResolver
    }
  },
  {
    path: 'mobile-capture',
    component: MobileCaptureWrapperComponent,
    children: [
      {
        path: ':computerId',
        component: MobileCaptureComponent
      }
    ]
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' }
];

export const CoreRoutes = routes;

